import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
export function EmptyState(props) {
    const { className } = props;
    if ('children' in props && props.children !== undefined) {
        return (_jsx("div", { className: cn('flex flex-col items-center gap-3 p-8 text-center', className), children: props.children }));
    }
    const { icon: Icon, title, description, action, } = props;
    return (_jsxs("div", { className: cn('flex flex-col items-center gap-3 p-8 text-center', className), children: [_jsx(Icon, { className: "h-12 w-12 text-[var(--color-text-muted)]", "aria-hidden": "true" }), _jsx("div", { className: "font-medium text-[var(--color-text-primary)]", children: title }), description != null ? (_jsx("div", { className: "text-sm text-[var(--color-text-muted)]", children: description })) : null, action] }));
}
//# sourceMappingURL=empty-state.js.map